import React from 'react'

const SvgVolumeMuteFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 16l4.537 3.927c.417.138.764.118 1.041-.058.278-.176.419-.476.422-.9l.004-13.679c.017-.576-.124-.953-.422-1.13-.298-.177-.645-.207-1.04-.09L6.003 8h-2c-1.333.006-2 .673-2 2 0 1.765-.004 3.448-.004 4.013 0 1.325.667 1.991 2 2L6 16zm9.351-.35l2.243-2.243 2.242 2.243c.464.48.935.48 1.415 0s.48-.95 0-1.414l-2.243-2.243L21.25 9.75c.471-.47.471-.942 0-1.414-.472-.47-.943-.47-1.415 0l-2.242 2.243-2.243-2.243c-.46-.482-.932-.482-1.414 0-.482.482-.482.954 0 1.414l2.242 2.243-2.242 2.243c-.472.47-.472.942 0 1.414s.943.472 1.414 0h.001z'
    />
  </svg>
)

export default SvgVolumeMuteFilled
